<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"><a id="pv"></a><span epub:type="pagebreak" id="pagev" title="v"><a id="fm"></a>Food riots have been spreading in the North of Scotland to so great an extent that several parties of military have been despatched from Edinburgh. In some parts the country is described to be nearly in a state of insurrection.</span></p>
<p class="right1"><em>Spectator</em>, 6 February 1847<a id="pvi"></a><span epub:type="pagebreak" id="pagevi" title="vi"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?f8952df4